

// contact form ajax
document.addEventListener('DOMContentLoaded', function () {
	const contactForms = document.querySelectorAll('.js-contact-form');

	contactForms.forEach(form => {
		form.addEventListener('submit', async function (ev) {
			ev.preventDefault();

			// Get a fresh token from Google
			var token = '';
			if (typeof grecaptcha !== 'undefined') {
				token = await grecaptcha.execute(itg_vars.captchaKey, { action: 'submit_form' });
			}

			const wrapper = form.closest('.contact-form-wrapper');
			const submitBtn = form.querySelector('.js-btn-submit');
			const thankYouDiv = wrapper.querySelector('.thank-you');

			// UI State: Loading
			submitBtn.disabled = true;
			submitBtn.innerText = 'שולח...';

			// Gather Data
			const formData = new FormData(form);
			formData.append('action', 'itg_submit_contact_form');
			formData.append('_wpnonce', itg_vars.nonce);
			formData.append('token', token);

			// Send AJAX
			fetch(itg_vars.ajax_url, {
				method: 'POST',
				body: formData
			})
				.then(response => response.json())
				.then(data => {
					if (data.success) {
						// Success logic
						form.style.display = 'none';
						thankYouDiv.style.display = 'flex';
						thankYouDiv.setAttribute('aria-hidden', 'false');
						form.reset();

					} else {
						alert('אירעה שגיאה: ' + (data.data.message || 'נסה שנית מאוחר יותר'));
						submitBtn.disabled = false;
						submitBtn.innerText = 'שליחת פנייה ←';
					}
				})
				.catch(error => {
					console.error('Error:', error);
					submitBtn.disabled = false;
				});
		});
	});
});
